import Home from './pages/Home';
import Charter from './pages/Charter';
import Voyagez from './pages/Voyagez';
import Realisation from './pages/Realisation';
import Contact from './pages/Contact';
import Decouvrir from './pages/Decouvrir';
import ScrollToTop from './components/ScrollToTop';
import EnCoursDeConstruction from './pages/EnCoursDeConstruction';
import Mentions from './pages/Mentions';
import PolitiqueConfidentialite from './pages/Politique';
import AdminLogin from './pages/Admin'

import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop /> 
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/voyagez" element={<Voyagez />} />
          <Route path="/charter" element={<Charter />} />
          <Route path="/realisation" element={<Realisation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/decouvrir" element={<Decouvrir />} />
          <Route path="/mentions-legales" element={<Mentions />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />}/>
          <Route path="/admin" element={<AdminLogin />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
